export const PATIENT_PROCESS_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

export const PATIENT_PROCESS_DEFAULT_PAGE_SIZE = 10;
